/**
 * GENERATED by /docs-writer from docs/agents-guide.md — DO NOT EDIT BY HAND.
 * Edit the markdown and run `/docs-writer update docs/agents-guide.md`.
 *
 * source-sha: 48e7c9f6e232c4c1cb5cff2789c8b82150182663
 * sources (from the markdown's "Sources" section):
 *   - Register, its four statuses, the synchronous add, heartbeat reply and cadence: apps/api/src/app/atlas-whitelist/atlas-whitelist.service.ts, apps/api/src/app/atlas-whitelist/agents.controller.ts, packages/inventory-core/src/agents/register.ts
 *   - Agent start, crash loop versus not ready, re-registration, leader-only polling, preflight: apps/agent/src/agent.ts, apps/agent/src/config.ts, apps/agent/src/health.ts, apps/agent/src/controller-client.ts, apps/agent/src/k8s/preflight.ts
 *   - Tokens, the 401 and 403 answers, the shared key: apps/api/src/app/atlas-whitelist/agent-cluster-token.guard.ts, packages/inventory-core/src/agents/tokens.ts, apps/api/src/app/atlas-whitelist/agents.resolver.ts
 *   - Targets, caps, entry states, target credentials and the Active flag: packages/shared-types/src/atlas.ts, apps/web/src/lib/atlas.ts, packages/inventory-core/src/atlas/credentials.ts, packages/inventory-core/src/atlas/db.ts, packages/inventory-core/src/atlas/reconcile.ts
 *   - Quiet and silent thresholds: packages/shared-types/src/agents.ts
 *   - The seven operations, plan, draft, approve, digest, expiry, attempts, the reaper's passes: packages/inventory-core/src/agents/commands.ts, apps/agent/src/commands/registry.ts, apps/agent/src/commands/executor.ts, apps/api/src/storage/migrations/025_agent_control.sql
 *   - The arguments infras sends, the plan-time value checks, the default namespace, leader routing, how rejected and cancelled results are stored, the namespace and registry allowlists: packages/inventory-core/src/agents/commands.ts, apps/api/src/app/atlas-whitelist/agents.controller.ts, contracts/agent-command-wire.json, apps/web/src/lib/agentCommands.ts, apps/web/src/components/AgentCommandDialog.tsx, apps/web/src/pages/AgentsPage.tsx, apps/agent/src/commands/validate.ts, apps/agent/src/commands/registry.ts, apps/agent/src/k8s/facade.ts, read on 2026-10-10
 *   - Agent image tags and the mutating flag on qa and beta: .gitlab-ci.yml, .optisigns/k8s-deployment/agent/README.md, docs/agents.md, conversation of 2026-10-10
 *   - Who can approve, who can read output, who can change cluster settings: packages/shared-types/src/rbac.ts, apps/api/src/app/atlas-whitelist/agent-commands.resolver.ts
 *   - Every screen, button and label named above: apps/web/src/pages/ClusterAccessPage.tsx, apps/web/src/pages/AgentsPage.tsx, apps/web/src/components/AgentCommandDialog.tsx, apps/web/src/pages/AgentCommandPage.tsx, apps/web/src/pages/AtlasMappingsPage.tsx, apps/web/src/pages/AtlasProjectPage.tsx, apps/web/src/pages/OverviewPage.tsx, apps/web/src/pages/cluster-access/CapacityBand.tsx, apps/web/src/pages/cluster-access/TargetEditForm.tsx, apps/web/src/pages/cluster-access/AddTargetWizard.tsx, apps/web/src/App.tsx
 *   - Scheduled jobs, their schedules and seeded state: apps/scheduler/src/jobs/agent-command-reaper/index.ts, apps/scheduler/src/jobs/atlas-drift-detect/index.ts, apps/scheduler/src/jobs/atlas-whitelist-reconcile/index.ts
 *   - The ClusterRole, the ConfigMap flags, the pod-logs Role, the two scripts: .optisigns/k8s-deployment/agent/base/clusterrole.yaml, .optisigns/k8s-deployment/agent/base/configmap.yaml, .optisigns/k8s-deployment/agent/base/daemonset.yaml, .optisigns/k8s-deployment/agent/optional/role-pod-logs.yaml, .optisigns/k8s-deployment/agent/scripts/apply-agent.sh, .optisigns/k8s-deployment/agent/scripts/bootstrap-cluster-secret.sh, .optisigns/k8s-deployment/agent/README.md
 *   - That self-upgrade has not run end to end, in the engineer notes: docs/agents.md (the engineers' design of record)
 *   - The two sequence diagrams, one source line per arrow: apps/agent/src/ip-detector.ts, apps/agent/src/agent.ts, apps/agent/src/controller-client.ts, apps/agent/src/commands/executor.ts, apps/agent/src/commands/registry.ts, apps/api/src/app/atlas-whitelist/agents.controller.ts, apps/api/src/app/atlas-whitelist/atlas-whitelist.service.ts, apps/api/src/app/atlas-whitelist/agent-cluster-token.guard.ts, apps/api/src/app/atlas-whitelist/agent-commands.resolver.ts, apps/api/src/app/atlas-whitelist/agents.resolver.ts, packages/inventory-core/src/agents/register.ts, packages/inventory-core/src/agents/db.ts, packages/inventory-core/src/agents/commands.ts, packages/shared-types/src/rbac.ts, apps/web/src/pages/AgentsPage.tsx, apps/web/src/components/AgentCommandDialog.tsx, apps/web/src/pages/AgentCommandPage.tsx, read on 2026-10-12
 */
import { Link } from 'react-router';
import { DocSequence } from '../components/DocSequence';
import { DocTopology } from '../components/DocTopology';
import { DocsToc } from '../components/DocsToc';

const TOC = [
  { id: 'register', label: 'How a node registers' },
  { id: 'auth', label: 'The cluster token' },
  { id: 'where', label: 'Where the address lands' },
  { id: 'fleet', label: 'Reading the fleet' },
  { id: 'commands', label: 'What the agent can run' },
  { id: 'approve', label: 'Preview, draft, approve' },
  { id: 'switches', label: 'Why a command is not running' },
  { id: 'jobs-the-agent-depends-on', label: 'Jobs the agent depends on' },
  { id: 'rbac', label: 'What the agent may touch in a cluster' },
  { id: 'onboarding', label: 'Onboard a cluster' },
];

// Matrix cells: the mark is drawn in CSS, the word is for screen readers.
const YES = (
  <span className="doc-yes">
    <span className="doc-vh">allowed</span>
  </span>
);
const NO = (
  <span className="doc-no">
    <span className="doc-vh">blocked</span>
  </span>
);

export function AgentsDocsPage() {
  return (
    <>
      <div className="page doc" id="top">
        <p className="doc-eyebrow">Operations · Guide</p>
        <h1 className="doc-title">The OptiSigns Agent</h1>
        <p className="doc-lede">
          The <strong>OptiSigns Agent</strong> runs in a Kubernetes cluster as a DaemonSet. Each pod reports its
          node&rsquo;s public egress IP, and infras adds that address to the database access lists the cluster is
          mapped to. The agent also runs <strong>seven approved operations</strong> inside the cluster, and only
          when four switches are on. You see and control all of it on{' '}
          <Link to="/cluster-access">Cluster access</Link>.
        </p>
        <p className="doc-meta">
          Updated <time dateTime="2026-10-14">14 Oct 2026</time>
        </p>
        <aside className="doc-note">
          <span className="doc-note-label">Note</span>
          <p>
            This page is about the agent that runs on cluster nodes. To connect an AI client, read{' '}
            <Link to="/docs/get-started">Get started</Link> and <Link to="/docs/mcp">MCP tools</Link>.
          </p>
        </aside>
        <p className="doc-p">
          This map shows where each part of the agent runs and what it talks to.
        </p>
        <DocTopology
          caption="The OptiSigns Agent and what it talks to, 12 October 2026"
          groups={[
            { id: 'Cluster', label: 'Kubernetes cluster', note: 'agent DaemonSet' },
          ]}
          nodes={[
            { id: 'Pod', label: 'Agent pod', note: 'on a node', group: 'Cluster' },
            { id: 'K8s', label: 'Kubernetes API', note: 'the cluster API', group: 'Cluster' },
            { id: 'Op', label: 'Operator', note: 'Agent fleet' },
            { id: 'Ip', label: 'IP lookup', note: 'web service' },
            { id: 'Api', label: 'infras' },
            { id: 'Atlas', label: 'MongoDB Atlas', note: 'access list' },
            { id: 'Fw', label: 'DigitalOcean', note: 'DB firewall' },
          ]}
          edges={[
            { from: 'Pod', to: 'K8s', text: 'command' },
            { from: 'Pod', to: 'Ip', text: 'public IP' },
            { from: 'Pod', to: 'Api', text: 'register' },
            { from: 'Op', to: 'Api' },
            { from: 'Api', to: 'Atlas', text: 'add IP' },
            { from: 'Api', to: 'Fw', text: 'add IP' },
          ]}
        />

        <h2 className="doc-h2" id="register">How a node registers</h2>
        <p className="doc-p">
          A pod registers once when it starts. Registration is what puts the node&rsquo;s address on the access
          lists.
        </p>
        <DocSequence
          caption="One node registers, from pod start to first heartbeat"
          participants={[
            { id: 'Op', label: 'Operator', kind: 'person' },
            { id: 'Pod', label: 'Agent pod', note: 'on a cluster node' },
            { id: 'Ip', label: 'IP lookup', note: 'a public web service' },
            { id: 'Api', label: 'infras' },
            { id: 'Lists', label: 'Access lists', note: 'Atlas or DigitalOcean' },
          ]}
          steps={[
            { kind: 'note', over: ['Pod'], text: 'Starts with the cluster name and token from its Secret' },
            { from: 'Pod', to: 'Ip', text: 'Ask for its public IP' },
            { kind: 'reply', from: 'Ip', to: 'Pod', text: 'Return the egress IP' },
            { from: 'Pod', to: 'Api', text: 'Register with cluster, node, IP, token' },
            { from: 'Api', to: 'Api', text: 'Check the token, record the node' },
            { from: 'Api', to: 'Lists', text: 'Add the IP to each list' },
            { kind: 'reply', from: 'Lists', to: 'Api', text: 'Answer for each list' },
            { kind: 'reply', from: 'Api', to: 'Pod', text: 'Reply with one of four statuses' },
            { from: 'Op', to: 'Api', text: 'Open Agent fleet' },
            { kind: 'reply', from: 'Api', to: 'Op', text: 'List the node' },
            { from: 'Pod', to: 'Api', text: 'Send the first heartbeat' },
            { kind: 'reply', from: 'Api', to: 'Pod', text: 'Return the next interval' },
          ]}
        />
        <p className="doc-p">
          infras replies only after every mapped access list has answered, so the reply carries the real outcome.
          It is one of the four statuses below. <Link to="/cluster-access/fleet">Agent fleet</Link> lists the
          node once infras has recorded it, with any of the four statuses and before the first heartbeat.
        </p>
        <p className="doc-p">
          The pod sends its first heartbeat after its configured interval, 5 minutes by default. After that it
          follows the interval infras returns: 60 seconds when idle, 5 seconds while an approved command waits
          for the cluster.
        </p>
        <div className="doc-table">
          <table>
            <thead>
              <tr>
                <th>Status</th>
                <th>What it means</th>
                <th>What the pod does</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>ok</code></td>
                <td>The IP is on every mapped access list. It was added, or it was already there.</td>
                <td>Reports ready.</td>
              </tr>
              <tr>
                <td><code>rate_limited</code></td>
                <td>Atlas answered an add with HTTP 429.</td>
                <td>Stays up, reports not ready, and registers again on its next heartbeat.</td>
              </tr>
              <tr>
                <td><code>failed</code></td>
                <td>An add failed, or a mapped target has no credential.</td>
                <td>
                  The same as <code>rate_limited</code>.
                </td>
              </tr>
              <tr>
                <td><code>no_targets</code></td>
                <td>The cluster is mapped to no target. The node is still recorded in the fleet.</td>
                <td>
                  The same as <code>rate_limited</code>. Map the cluster under <strong>Cluster mapping</strong>.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="doc-p">
          <strong>A registration refused at start stops the pod.</strong> The process exits, Kubernetes restarts
          it, and the pod shows <code>CrashLoopBackOff</code>. infras refuses a registration in three cases.
        </p>
        <ul className="doc-list">
          <li>
            <strong>The token is wrong or disabled.</strong> infras answers 401.
          </li>
          <li>
            <strong>The cluster&rsquo;s name does not match the token.</strong> infras answers 403.
          </li>
          <li>
            <strong>The agent asks for a target the cluster is not mapped to.</strong> infras answers 400.
          </li>
        </ul>
        <p className="doc-p">
          The pod exits the same way when its cluster name or token is missing, when the IP lookup fails, or when
          it cannot reach infras.
        </p>
        <p className="doc-p">
          <strong>An access-list failure keeps the pod running.</strong> With <code>rate_limited</code>,{' '}
          <code>failed</code> or <code>no_targets</code> the node stays registered. The pod reports not ready and
          registers again on every heartbeat until the status is <code>ok</code>. When a heartbeat itself fails,
          the pod registers again. If that also fails, the pod stays up and reports not ready.
        </p>
        <aside className="doc-note">
          <span className="doc-note-label">Note</span>
          <p>
            A pod whose registration ended <code>ok</code> does not register again while its heartbeats succeed.
            A pod restart or a failed heartbeat makes it register. That registration puts the node&rsquo;s address
            back on its access lists, even when a person removed it, and the fleet records the override as an
            event on the agent.
          </p>
        </aside>

        <h2 className="doc-h2" id="auth">The cluster token</h2>
        <p className="doc-p">
          Each cluster has one bearer token. The agent sends it with the cluster&rsquo;s name on every call, and
          infras stores only a bcrypt hash of it.
        </p>
        <p className="doc-p">
          You manage tokens on <Link to="/cluster-access/fleet">Agent fleet</Link>, in the section{' '}
          <strong>Agent cluster tokens</strong> under the node list. The <strong>root</strong> and{' '}
          <strong>maintainer</strong> roles can change them.
        </p>
        <ul className="doc-list">
          <li>
            <strong>Mint.</strong> Type the cluster&rsquo;s name and press <strong>Mint token</strong>. The token
            is shown once. Copy it then.
          </li>
          <li>
            <strong>Rotate.</strong> <strong>Rotate</strong> replaces the token at once. An agent that still sends
            the old one gets a 401 until the cluster&rsquo;s Secret carries the new one and its pods restart.
            Rotating also turns a disabled token back on.
          </li>
          <li>
            <strong>Disable.</strong> <strong>Disable</strong> makes infras refuse the token with a 401.{' '}
            <strong>Enable</strong> turns it back on.
          </li>
          <li>
            <strong>Last used.</strong> The table shows when each token last authenticated a call.
          </li>
        </ul>

        <h2 className="doc-h2" id="where">Where the address lands</h2>
        <p className="doc-p">
          A cluster is mapped to one or more <strong>targets</strong>. A target is a MongoDB Atlas project or a
          DigitalOcean managed-database firewall. <Link to="/cluster-access">Cluster access</Link> counts an
          Atlas list against 200 entries and a DigitalOcean firewall against 100 rules.
        </p>
        <p className="doc-p">Open a target to see its access list. Each entry has one of five states.</p>
        <div className="doc-table">
          <table>
            <thead>
              <tr>
                <th>State</th>
                <th>What it means</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>in sync</code></td>
                <td>The address is on the list and an agent reports it.</td>
              </tr>
              <tr>
                <td><code>no agent</code></td>
                <td>The address is on the list and nothing reports it. It uses a slot.</td>
              </tr>
              <tr>
                <td><code>stale</code></td>
                <td>
                  An agent reported the address and has sent no heartbeat for more than 15 minutes. The slot can
                  be reclaimed.
                </td>
              </tr>
              <tr>
                <td><code>manual</code></td>
                <td>Someone added the entry by hand, outside infras. It is never counted as reclaimable.</td>
              </tr>
              <tr>
                <td><code>open to all</code></td>
                <td>
                  The entry is a <code>/0</code>, which admits every address on the internet.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="doc-p">
          <Link to="/overview">Overview</Link> pins an <code>open to all</code> entry above every other finding.
          The prune refuses to remove one, because everything that relies on it would lose access. Remove it in
          the provider&rsquo;s own console.
        </p>
        <aside className="doc-note">
          <span className="doc-note-label">Note</span>
          <p>
            To stop agents adding to a target, remove the target&rsquo;s credential. Registrations then return{' '}
            <code>failed</code> for it. Clearing <strong>Active</strong> on a target stops the scheduled reconcile
            and hides the target from the mapping list. A registering agent still adds its address to it.
          </p>
        </aside>

        <h2 className="doc-h2" id="fleet">Reading the fleet</h2>
        <p className="doc-p">
          <Link to="/cluster-access/fleet">Agent fleet</Link> lists every registered node, grouped by cluster. A
          row shows the node&rsquo;s status, its name and last heartbeat, its IP address, its agent version and
          whether it is the cluster&rsquo;s leader.
        </p>
        <p className="doc-p">
          infras decides whether a node is alive from one timestamp, its last heartbeat. Two thresholds apply.
        </p>
        <div className="doc-table">
          <table>
            <thead>
              <tr>
                <th>Label</th>
                <th>No heartbeat for</th>
                <th>Where it shows</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Quiet</strong></td>
                <td>more than 10 minutes</td>
                <td>The fleet only.</td>
              </tr>
              <tr>
                <td><strong>Silent</strong></td>
                <td>more than 15 minutes</td>
                <td>
                  The fleet, the count in the cluster&rsquo;s header and the checklist on{' '}
                  <Link to="/overview">Overview</Link>.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="doc-p">
          <strong>Silent is a finding, and a person decides what follows.</strong> infras never removes an agent
          or an address on its own. A <strong>root</strong> ticks silent agents and presses{' '}
          <strong>Remove selected…</strong>, which shows a preview before anything changes. Only silent agents can
          be ticked.
        </p>
        <p className="doc-p">
          The status filter has three entries that answer common questions:{' '}
          <strong>Silent (&gt; 15 min)</strong>, <strong>Whitelisting failed</strong> and{' '}
          <strong>Missing from Atlas</strong>.
        </p>
        <p className="doc-p">Each cluster&rsquo;s header carries its state.</p>
        <ul className="doc-list">
          <li>
            <strong>desired</strong> and <strong>on desired.</strong> The agent release the cluster should run,
            and how many of its agents run it.
          </li>
          <li>
            <strong>production.</strong> Mutating commands on this cluster need root approval. A root can click
            the pill to clear it.
          </li>
          <li>
            <strong>commands on</strong> or <strong>commands off.</strong> Whether infras hands commands to this
            cluster. A root can click the pill to change it.
          </li>
          <li>
            <strong>The actions menu.</strong> It holds <strong>Pods</strong>, <strong>Upgrade</strong> and{' '}
            <strong>Command log</strong>.
          </li>
        </ul>
        <p className="doc-p">
          One agent per cluster holds a Kubernetes Lease and reports that it is the <strong>leader</strong>.
          Kubernetes elects it, and infras only records what the agents report. The <strong>Leader</strong> column
          marks that agent and shows when infras last saw it as leader. The mark moves only when another agent
          reports that it holds the Lease. On a cluster whose agents went quiet, read the time under the mark
          before you trust it.
        </p>

        <h2 className="doc-h2" id="commands">What the agent can run</h2>
        <p className="doc-p">
          The agent runs a closed list of seven operations. infras can dispatch only these, and the agent refuses
          anything that is not in its own list. There is no remote shell.
        </p>
        <div className="doc-table">
          <table>
            <thead>
              <tr>
                <th>Operation</th>
                <th>What it is for</th>
                <th>Mutating</th>
                <th>Where you start it</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>pod.list</code></td>
                <td>Lists the pods in a namespace, with an optional label selector.</td>
                <td>No</td>
                <td>
                  <strong>Pods</strong> in the cluster&rsquo;s actions menu
                </td>
              </tr>
              <tr>
                <td><code>workload.status</code></td>
                <td>Reads the status of one DaemonSet or Deployment.</td>
                <td>No</td>
                <td>
                  The <strong>Operation</strong> list in the command dialog
                </td>
              </tr>
              <tr>
                <td><code>pod.logs</code></td>
                <td>Tails one pod&rsquo;s logs. 200 lines by default, 1,000 at most.</td>
                <td>No</td>
                <td>
                  <strong>Logs</strong> on a node&rsquo;s row
                </td>
              </tr>
              <tr>
                <td><code>daemonset.restart</code></td>
                <td>Rolling restart of a DaemonSet.</td>
                <td>Yes</td>
                <td>
                  <strong>Restart</strong> on a node&rsquo;s row, for the agent&rsquo;s own DaemonSet
                </td>
              </tr>
              <tr>
                <td><code>deployment.restart</code></td>
                <td>Rolling restart of a Deployment.</td>
                <td>Yes</td>
                <td>
                  The <strong>Operation</strong> list
                </td>
              </tr>
              <tr>
                <td><code>deployment.scale</code></td>
                <td>Sets a Deployment&rsquo;s replicas, from 0 to 50.</td>
                <td>Yes</td>
                <td>
                  The <strong>Operation</strong> list
                </td>
              </tr>
              <tr>
                <td><code>agent.self_upgrade</code></td>
                <td>Rolls the agent&rsquo;s DaemonSet to a given image.</td>
                <td>Yes</td>
                <td>
                  <strong>Upgrade</strong> in the cluster&rsquo;s actions menu
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="doc-p">
          <strong>infras checks a command before you can draft it.</strong> The preview refuses a value the agent
          would refuse, and names the field.
        </p>
        <ul className="doc-list">
          <li>
            <strong>Names.</strong> A workload or pod name is lowercase letters, digits, <code>-</code> and{' '}
            <code>.</code>, at most 253 characters.
          </li>
          <li>
            <strong>Namespace.</strong> Lowercase letters, digits and <code>-</code>, at most 63 characters. A
            blank <strong>Namespace</strong> becomes <code>platform</code>, and the dialog fills that value in for
            you.
          </li>
          <li>
            <strong>Label selector.</strong> Letters, digits, spaces and <code>. _ / = ! , ( ) -</code>, at most
            256 characters.
          </li>
          <li>
            <strong>Image.</strong> A semver tag such as <code>1.4.0</code> or <code>v1.4.0-sbx</code>, or a{' '}
            <code>sha256</code> digest. The tag <code>latest</code> is never accepted.
          </li>
        </ul>
        <p className="doc-p">
          <strong>Every command runs on the cluster&rsquo;s leader.</strong> <strong>Logs</strong> and{' '}
          <strong>Restart</strong> on a node&rsquo;s row open the same dialog as the cluster&rsquo;s actions menu,
          and the leader runs the command whichever row you start from. <strong>Restart</strong> restarts the
          agent&rsquo;s whole DaemonSet, so its pod on every node is replaced. It does not restart one
          node&rsquo;s pod.
        </p>
        <DocSequence
          caption="One command, from draft to result"
          participants={[
            { id: 'Op', label: 'Operator', kind: 'person', note: 'root or maintainer' },
            { id: 'Ap', label: 'Approver', kind: 'person', note: 'can be the same person' },
            { id: 'Api', label: 'infras' },
            { id: 'Ag', label: 'Leader agent', note: 'in the cluster' },
            { id: 'K8s', label: 'Kubernetes', note: 'the cluster API' },
          ]}
          steps={[
            { from: 'Op', to: 'Api', text: 'Draft the command' },
            { kind: 'note', over: ['Ap'], text: 'Root only for a mutating command on production' },
            { from: 'Ap', to: 'Api', text: 'Approve the draft' },
            { from: 'Api', to: 'Api', text: 'Recheck the plan, queue it' },
            { from: 'Ag', to: 'Api', text: 'Ask for work' },
            { kind: 'reply', from: 'Api', to: 'Ag', text: 'Hand over the claimed command' },
            { from: 'Ag', to: 'Ag', text: 'Check operation, flags and arguments' },
            {
              kind: 'note',
              over: ['Api', 'Ag'],
              text: (
                <>
                  A switched-off operation or a refused argument stops here. The command ends{' '}
                  <code>failed</code>, and its error starts <code>rejected by agent:</code>
                </>
              ),
            },
            { from: 'Ag', to: 'K8s', text: 'Run the operation' },
            { kind: 'reply', from: 'K8s', to: 'Ag', text: 'Return the outcome' },
            { from: 'Ag', to: 'Api', text: 'Report the result' },
            { from: 'Op', to: 'Api', text: 'Open the command' },
            { kind: 'reply', from: 'Api', to: 'Op', text: 'Show its status and every change' },
          ]}
        />
        <p className="doc-p">
          The agent starts every exchange with infras. An approved command stays <code>queued</code> until the
          leader asks for work, and infras hands it over in its answer.
        </p>
        <aside className="doc-note">
          <span className="doc-note-label">Note</span>
          <p>
            The agent runs a command only in a namespace its own configuration allows. That is the agent&rsquo;s
            own namespace plus any listed in <code>AGENT_ALLOWED_NAMESPACES</code>, which is empty by default.
            infras cannot read that list. A command for another namespace can be approved, and it then ends{' '}
            <code>failed</code> with an error that names the namespace.
          </p>
        </aside>
        <p className="doc-p">
          <strong>Upgrade</strong> opens the dialog with the cluster&rsquo;s desired release filled in. It is
          disabled when every agent already runs that release. The agent accepts only an image from its registry
          allowlist.
        </p>
        <aside className="doc-note">
          <span className="doc-note-label">Note</span>
          <p>
            The agent images built on each merge carry a tag made of <code>sbx-</code> or <code>prod-</code> and a
            commit id. That is not a semver tag, so the preview refuses such an image as an upgrade target. Only
            an image built from a release tag, or one given by its digest, can be used for{' '}
            <strong>Upgrade</strong>.
          </p>
        </aside>
        <p className="doc-p">
          Publishing a release and pinning a cluster to a version have no screen. A root does both through the
          GraphQL API, with the mutations <code>upsertAgentRelease</code> and{' '}
          <code>setClusterAgentSettings</code>.
        </p>
        <p className="doc-p">
          A command&rsquo;s output holds at most 256 KiB. It is stored apart from the command, and you fetch it
          with <strong>Load output</strong> on the command&rsquo;s page. The root and maintainer roles can read
          it.
        </p>
        <aside className="doc-note">
          <span className="doc-note-label">Note</span>
          <p>
            Prove the command path with <strong>Pods</strong> before anything else. It is read-only and needs no
            extra flag on the agent.
          </p>
        </aside>

        <h2 className="doc-h2" id="approve">Preview, draft, approve</h2>
        <p className="doc-p">
          Every operation goes through the same steps, and approval is the only way a command reaches a cluster.
        </p>
        <ol className="doc-list">
          <li>
            <strong>Preview.</strong> Choose an action in the fleet. The dialog shows a summary, a diff and any
            warnings. Nothing is saved.
          </li>
          <li>
            <strong>Draft.</strong> Press <strong>Create draft</strong>. infras saves the command with that plan
            and a digest of everything you were shown.
          </li>
          <li>
            <strong>Approve.</strong> Press <strong>Approve</strong>, or <strong>Approve &amp; dispatch</strong>{' '}
            for a mutating operation. infras computes the plan again and compares the digests. If the
            cluster&rsquo;s settings, its desired release or the state of its agents changed in between, infras
            refuses and the dialog shows the new diff.
          </li>
          <li>
            <strong>Follow it.</strong> Press <strong>Command log</strong> on Cluster access and open the command.
            Every state change is recorded there with who made it.
          </li>
        </ol>
        <p className="doc-p">
          A <code>✓</code> means the role can approve. A <code>–</code> means it cannot.
        </p>
        <div className="doc-table doc-matrix">
          <table>
            <thead>
              <tr>
                <th scope="col">Role</th>
                <th scope="col">Read-only operation</th>
                <th scope="col">Mutating, cluster not production</th>
                <th scope="col">Mutating, production cluster</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row"><strong>root</strong></th>
                <td>{YES}</td>
                <td>{YES}</td>
                <td>{YES}</td>
              </tr>
              <tr>
                <th scope="row"><strong>maintainer</strong></th>
                <td>{YES}</td>
                <td>{YES}</td>
                <td>{NO}</td>
              </tr>
              <tr>
                <th scope="row"><strong>Any other role</strong></th>
                <td>{NO}</td>
                <td>{NO}</td>
                <td>{NO}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ul className="doc-list">
          <li>
            <strong>Production is the default.</strong> A cluster with no agent settings counts as production.
          </li>
          <li>
            <strong>A maintainer can still file the draft.</strong> The button reads{' '}
            <strong>Request root approval</strong>, and the dialog links the draft to send to a root.
          </li>
          <li>
            <strong>A mutating command on production asks for the cluster&rsquo;s name.</strong> You type it
            before <strong>Approve &amp; dispatch</strong> unlocks.
          </li>
          <li>
            <strong>Commands must be on for the cluster.</strong> You can draft while they are off, and the
            preview warns you. infras refuses the approval.
          </li>
        </ul>
        <aside className="doc-note">
          <span className="doc-note-label">Note</span>
          <p>
            No call queues a command directly. A command becomes dispatchable only when someone approves its
            draft, and the database refuses a queued command that has no approver.
          </p>
        </aside>

        <h2 className="doc-h2" id="switches">Why a command is not running</h2>
        <p className="doc-p">A command runs only when four switches are on. All four are off by default.</p>
        <div className="doc-table">
          <table>
            <thead>
              <tr>
                <th>Switch</th>
                <th>Where it is set</th>
                <th>When it is off</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Leader election</strong></td>
                <td>
                  <code>AGENT_LEADER_ELECTION_ENABLED</code> in the cluster&rsquo;s{' '}
                  <code>optisigns-agent-config</code> ConfigMap
                </td>
                <td>
                  Only the leader asks infras for commands. Without an election there is no leader, so no agent
                  asks.
                </td>
              </tr>
              <tr>
                <td><strong>Commands for the cluster</strong></td>
                <td>
                  The <strong>commands on</strong> or <strong>commands off</strong> pill on the cluster in Agent
                  fleet. Root only.
                </td>
                <td>infras hands the cluster nothing and refuses approvals for it.</td>
              </tr>
              <tr>
                <td><strong>Commands on the agents</strong></td>
                <td>
                  <code>AGENT_COMMANDS_ENABLED</code> in the same ConfigMap
                </td>
                <td>The agents never ask for commands.</td>
              </tr>
              <tr>
                <td><strong>The operation&rsquo;s flag</strong></td>
                <td>
                  <code>AGENT_MUTATING_OPS_ENABLED</code> for the four mutating operations.{' '}
                  <code>AGENT_POD_LOGS_ENABLED</code> and the Role in <code>optional/role-pod-logs.yaml</code> for{' '}
                  <code>pod.logs</code>.
                </td>
                <td>The agent receives the command and refuses it.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="doc-p">
          Turn the agent flags on in this order, one cluster at a time: leader election, commands, mutating. The
          pods read the flags when they start, so a changed flag takes effect after the DaemonSet&rsquo;s pods
          restart. With the first three switches on and both operation flags off, an agent runs{' '}
          <code>pod.list</code> and <code>workload.status</code>.
        </p>
        <aside className="doc-note">
          <span className="doc-note-label">Note</span>
          <p>
            The four mutating operations are switched off on the qa and beta clusters. A mutating command approved
            there ends <code>failed</code>.
          </p>
        </aside>
        <p className="doc-p">With all four switches on, the agent still refuses a command in two cases.</p>
        <ul className="doc-list">
          <li>
            <strong>Namespace is outside the agent&rsquo;s allowlist.</strong> The agent works in its own
            namespace and in any namespace listed in <code>AGENT_ALLOWED_NAMESPACES</code>. That list is empty by
            default.
          </li>
          <li>
            <strong>The upgrade image is outside the agent&rsquo;s registry allowlist.</strong> infras checks the
            form of an image and cannot read that list.
          </li>
        </ul>
        <p className="doc-p">
          <strong>A refusal is recorded with its reason.</strong> infras cannot read an agent&rsquo;s flags or
          allowlists, so it approves such a command and the agent then refuses it. When the agent refuses because
          an operation&rsquo;s flag is off or an argument is not accepted, the command ends <code>failed</code> at
          once, and its error starts with <code>rejected by agent: </code> followed by the agent&rsquo;s reason.
          The command&rsquo;s page shows that error. The fleet does not grey out <strong>Logs</strong>,{' '}
          <strong>Restart</strong> or <strong>Upgrade</strong> for a switched-off operation.
        </p>
        <p className="doc-p">
          A finished command keeps its result. infras accepts one result for a command, from the agent that holds
          it, and refuses any later report.
        </p>
        <p className="doc-p">
          Draft again any command that was drafted or queued before infras started sending these arguments. An
          older draft cannot be approved, because its plan no longer matches.
        </p>
        <p className="doc-p">When a command sits still, check in this order.</p>
        <ol className="doc-list">
          <li>
            <strong>Its status in Command log.</strong> <code>draft</code> means nobody approved it.{' '}
            <code>expired</code> means 30 minutes passed since it was drafted. Approving does not extend that
            time. <code>failed</code> with an error that starts <code>rejected by agent: </code> means the agent
            refused the command, and the reason follows. <code>failed</code> with{' '}
            <code>lease expired and no attempts remain</code> means an agent took the command and infras recorded
            no result before the lease ran out. <code>cancelled</code> means someone cancelled it, before or while
            the agent ran it.
          </li>
          <li>
            <strong>The cluster&rsquo;s pill.</strong> It must read <strong>commands on</strong>.
          </li>
          <li>
            <strong>The leader.</strong> The fleet must show a leader with a recent time. The preview warns when
            no agent reports leadership. A command waits as <code>queued</code> until a leader asks for it.
          </li>
          <li>
            <strong>Another mutating command.</strong> A cluster runs one mutating command at a time.
          </li>
          <li>
            <strong>The reaper job.</strong> A command gets two attempts, and the reaper is what retries, fails or
            expires it. See the next section.
          </li>
        </ol>

        <h2 className="doc-h2" id="jobs-the-agent-depends-on">Jobs the agent depends on</h2>
        <p className="doc-p">
          Three scheduled jobs sit behind the fleet. Each one is created disabled. Open{' '}
          <Link to="/scheduler">Scheduler</Link> to see whether it is on in this environment.
        </p>
        <div className="doc-table">
          <table>
            <thead>
              <tr>
                <th>Job</th>
                <th>Runs</th>
                <th>What it does</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>agent-command-reaper</code></td>
                <td>every minute</td>
                <td>
                  Retries or fails a command whose agent stopped answering, expires a command after its 30
                  minutes, and confirms an agent upgrade from the cluster&rsquo;s own heartbeats.
                </td>
              </tr>
              <tr>
                <td><code>atlas-drift-detect</code></td>
                <td>every 30 minutes</td>
                <td>
                  Reports each address that a heartbeating agent owns and its access list has lost. It only
                  reads. It feeds the drift line on Overview.
                </td>
              </tr>
              <tr>
                <td><code>atlas-whitelist-reconcile</code></td>
                <td>every 15 minutes</td>
                <td>
                  Adds reported addresses to Atlas access lists. It only adds, and it never touches a
                  DigitalOcean firewall.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="doc-p">
          By its default settings the reaper also deletes command output after 30 days and command records after
          180 days.
        </p>
        <aside className="doc-note doc-note--warn">
          <span className="doc-note-label">Warning</span>
          <p>
            Turn <code>agent-command-reaper</code> on wherever commands are on. Without it, one mutating command
            whose agent died blocks every later mutating command on that cluster.
          </p>
        </aside>
        <aside className="doc-note">
          <span className="doc-note-label">Note</span>
          <p>
            The drift line on Overview is empty when nothing drifted, and also when{' '}
            <code>atlas-drift-detect</code> is off. No job puts a lost address back. A root does that with{' '}
            <strong>Restore…</strong> in the fleet.
          </p>
        </aside>

        <h2 className="doc-h2" id="rbac">What the agent may touch in a cluster</h2>
        <p className="doc-p">
          The agent&rsquo;s ServiceAccount holds one ClusterRole. It applies in every namespace, including one
          created later.
        </p>
        <div className="doc-table">
          <table>
            <thead>
              <tr>
                <th>Access</th>
                <th>What it covers</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Read</strong></td>
                <td>
                  get, list and watch on pods, services, namespaces, deployments, daemonsets, statefulsets,
                  replicasets, jobs and cronjobs
                </td>
              </tr>
              <tr>
                <td><strong>Patch</strong></td>
                <td>deployments, daemonsets and the scale of a deployment</td>
              </tr>
              <tr>
                <td><strong>Leader Lease</strong></td>
                <td>create Leases, and get and update its own leader Lease</td>
              </tr>
              <tr>
                <td><strong>Pod logs</strong></td>
                <td>
                  Outside the ClusterRole. A separate Role in <code>optional/role-pod-logs.yaml</code>, beside
                  the <code>scripts</code> folder, grants <code>get</code> on pod logs in the{' '}
                  <code>platform</code> namespace. You apply it by hand on each cluster that needs it. Every agent
                  pod on that cluster can then read every pod&rsquo;s log in that namespace.
                </td>
              </tr>
              <tr>
                <td><strong>Never</strong></td>
                <td>
                  secrets, configmaps, exec into a pod, port-forward, roles, role bindings and cluster roles. The
                  agent cannot create or delete a workload.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <aside className="doc-note doc-note--warn">
          <span className="doc-note-label">Warning</span>
          <p>
            Patch on a workload can change its whole spec, including the image, the command, the environment and
            the service account. The ClusterRole does not narrow that in any namespace. Three other things bound
            a mutating command: the <code>AGENT_MUTATING_OPS_ENABLED</code> flag, the{' '}
            <code>AGENT_ALLOWED_NAMESPACES</code> list the agent checks on every call, and approval in infras. An
            empty list means the agent&rsquo;s own namespace only. To give the agent more reach, widen that list
            and leave the ClusterRole alone.
          </p>
        </aside>
        <p className="doc-p">
          Kubernetes grants these rights to the ServiceAccount, so every agent pod holds them. The leader is the
          only pod that asks for commands.
        </p>
        <p className="doc-p">
          An agent with leader election or commands on checks its own permissions when it starts and prints an
          ALLOW and DENY table in its log. The line for reading secrets is labelled <code>MUST BE DENIED</code>.
          A <code>SECURITY WARNING</code> under that table means the grant was widened. The check only warns and
          never stops the pod. With both switches off, the agent does not call the Kubernetes API at all.
        </p>

        <h2 className="doc-h2" id="onboarding">Onboard a cluster</h2>
        <ol className="doc-list">
          <li>
            <strong>Map the cluster.</strong> On <Link to="/cluster-access">Cluster access</Link> press{' '}
            <strong>Cluster mapping</strong>, then <strong>Add mapping</strong>, and map the cluster to each
            target its nodes must reach.
          </li>
          <li>
            <strong>Check each target&rsquo;s credential.</strong> <strong>Add target</strong> asks for it: an
            OAuth client id and secret for Atlas, an API token for DigitalOcean. For an existing target, open it,
            press <strong>Edit</strong> and fill <strong>Rotate OAuth client secret</strong> or{' '}
            <strong>Rotate DO API token</strong>. Without a credential every registration returns{' '}
            <code>failed</code> for that target.
          </li>
          <li>
            <strong>Mint the cluster&rsquo;s token</strong> on{' '}
            <Link to="/cluster-access/fleet">Agent fleet</Link> and copy it.
          </li>
          <li>
            <strong>Create the cluster&rsquo;s Secret.</strong> Run <code>bootstrap-cluster-secret.sh</code> with
            the cluster&rsquo;s name. It takes the token from the <code>CLUSTER_TOKEN</code> environment variable
            when that is set. Otherwise it asks for the token with the input hidden. It never prints the token.
          </li>
          <li>
            <strong>Apply the manifests.</strong> Run <code>apply-agent.sh</code> with the cluster&rsquo;s name.
            It prints the full diff and makes you type the cluster&rsquo;s name. It has no flag that skips the
            question, and no pipeline runs it.
          </li>
          <li>
            <strong>Watch the rollout</strong>, then find the cluster&rsquo;s nodes in Agent fleet.
          </li>
        </ol>
        <p className="doc-p">
          Run the scripts from the infras-app repository, with your kubeconfig pointing at the cluster.
        </p>
        <pre className="doc-code">
          <code>{`kubectl -n platform get secret regcred
cd .optisigns/k8s-deployment/agent/scripts
./bootstrap-cluster-secret.sh <cluster>
./apply-agent.sh <cluster>
kubectl -n platform rollout status daemonset/optisigns-agent --timeout=30m`}</code>
        </pre>
        <p className="doc-p">
          Do step 4 before step 5. The DaemonSet reads the cluster&rsquo;s name and token from that Secret, and
          its pods stop in <code>CreateContainerConfigError</code> without it.
        </p>
        <p className="doc-p">
          The DaemonSet pulls the agent&rsquo;s image with the secret <code>regcred</code> in the{' '}
          <code>platform</code> namespace, and the first command above checks that it exists. Without it the pods
          stop in <code>ImagePullBackOff</code>. <code>README.md</code> in the folder above the scripts has the
          command that copies the secret from another namespace.
        </p>
        <aside className="doc-note doc-note--warn">
          <span className="doc-note-label">Warning</span>
          <p>
            The base manifests carry the four agent flags as off and <code>AGENT_ALLOWED_NAMESPACES</code> as
            empty. When you run <code>apply-agent.sh</code> on a cluster where you changed any of them, the
            script either shows the values going back in its diff, or stops on a field-ownership conflict and
            applies nothing. Read the diff before you type the cluster&rsquo;s name. Applying it turns commands
            off on a cluster that had them on.
          </p>
        </aside>

        <aside className="doc-next">
          <div>
            <h2 className="doc-next-title">Checking a cluster?</h2>
            <p>The fleet shows its nodes, its leader and its switches on one screen.</p>
          </div>
          <Link className="btn" to="/cluster-access/fleet">
            Open the agent fleet
          </Link>
        </aside>

        <p className="doc-back">
          <a href="#top">Back to top ↑</a>
        </p>
      </div>
      <DocsToc items={TOC} />
    </>
  );
}
